// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text, Graphics } from 'pixi.js';
import { ShopOfferRewardsLayout } from './ShopOfferRewardsLayout';
import { ButtonLargeLayout } from '../../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '1ad727cc-e035-4f03-8f1a-fc57fe57eada',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Yellow_Bundle_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        basic_offer: {
          texture: 'Yellow_Bundle_Background'
        },
        special_offer: {
          texture: 'Purple_Bundle_Background'
        }
      }
    },
    {
      id: 'b1b00b5f-7037-4807-b78b-3082564d831f',
      type: 'Text',
      name: 'coinRewardText',
      className: '',
      x: -222,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xXXXX',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 47,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#1B2C7D',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '1d6e83e4-4af2-496f-b579-edc919c025fc',
      type: 'Text',
      name: 'offerName',
      className: '',
      x: -325,
      y: 97,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Bundle Name',
      localize: false,
      maxWidth: 370,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 46,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8F2C2B',
        stroke: '#FFEC67',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 1,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        basic_offer: {
          style: {
            fill: '#8F2C2B',
            stroke: '#FFEC67'
          }
        },
        special_offer: {
          style: {
            fill: '#FFFFFF',
            stroke: '#1B2C7D'
          }
        }
      }
    },
    {
      id: '248ef3c0-891d-4a73-b5cb-16a3840c4081',
      type: 'Container',
      name: 'buyButton',
      className: '',
      x: 220,
      y: 99,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '85b4c822-68e5-443c-942d-6f3b471b3011',
      type: 'Container',
      name: 'legacyRibbonValue',
      className: '',
      x: -395,
      y: -224,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '2d5eb6e6-a27f-4986-994f-6fdb17a63cc5',
      type: 'Sprite',
      name: 'coinsShadow',
      className: '',
      x: -225,
      y: -51,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_Bundle_Shadow_Yellow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        basic_offer: {
          texture: 'Coins_Bundle_Shadow_Yellow'
        },
        special_offer: {
          texture: 'Coins_Bundle_Shadow_Purple'
        }
      }
    },
    {
      id: 'bfedd7f7-6d54-484b-86bb-69a735167e9c',
      type: 'Sprite',
      name: '',
      className: '',
      x: -222,
      y: -83,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_Bundle',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'e081c51a-bbf8-40ca-9f64-f5cedff22a88',
      type: 'Layout',
      name: 'rewardsLayout',
      className: '',
      path: 'mainMenu/shop/ShopOfferRewardsLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 118,
      y: -74,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '91c78ad2-d294-4874-9493-ea5d3974967b',
      type: 'Graphics',
      name: 'bannerContainer',
      className: '',
      x: 199,
      y: -205,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      commands: []
    },
    {
      id: '8d23aa01-52d9-4824-82da-918fbe3d578e',
      type: 'Container',
      name: 'timerContainer',
      className: '',
      x: -246,
      y: -178,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '98f5be9e-11e3-4f60-8205-455ae6e2b731',
      type: 'Layout',
      name: 'nineSliceButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 1,
      scale: {
        x: 0.77,
        y: 0.83
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '248ef3c0-891d-4a73-b5cb-16a3840c4081',
      data: {
        color: 'green'
      }
    },
    {
      id: '7b249c97-334e-41d7-8dc8-8cf7bcd7fa4b',
      type: 'Text',
      name: 'priceLabelText',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$5,49',
      localize: false,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#01632D',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '248ef3c0-891d-4a73-b5cb-16a3840c4081'
    },
    {
      id: '728d9485-f343-45ab-957f-bbdb749650ea',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Special_Offer_Pink_Ribbon',
      parent: '85b4c822-68e5-443c-942d-6f3b471b3011'
    },
    {
      id: '902ef33a-efa0-471a-bf6f-0afb0621bcaa',
      type: 'Container',
      name: '',
      className: '',
      x: 104,
      y: 29,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '85b4c822-68e5-443c-942d-6f3b471b3011'
    },
    {
      id: '2063a8ef-c52d-45e9-af54-018e2a154828',
      type: 'Sprite',
      name: 'banner',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Red_Banner',
      parent: '91c78ad2-d294-4874-9493-ea5d3974967b'
    },
    {
      id: '15df89b7-f55c-4981-82f4-abad93b6eb7e',
      type: 'Text',
      name: 'bannerText',
      className: '',
      x: 119,
      y: 64,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 45,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'POPULAR',
      localize: true,
      maxWidth: 140,
      maxHeight: 60,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '91c78ad2-d294-4874-9493-ea5d3974967b'
    },
    {
      id: '673f8e4e-4b39-4c3a-87eb-127d2da1a3a6',
      type: 'Sprite',
      name: 'timer',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Timer_Background',
      parent: '8d23aa01-52d9-4824-82da-918fbe3d578e'
    },
    {
      id: 'ad055db6-4c0d-49d6-b9a8-f8ff8de306d5',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1d20h',
      localize: false,
      maxWidth: 150,
      maxHeight: 40,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8d23aa01-52d9-4824-82da-918fbe3d578e'
    },
    {
      id: '33f22ad2-09ce-4f05-96ca-48dea5d427db',
      type: 'Sprite',
      name: '',
      className: '',
      x: -95,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: '8d23aa01-52d9-4824-82da-918fbe3d578e'
    },
    {
      id: '299597d0-6579-4c7c-a050-16190bb5f124',
      type: 'Text',
      name: 'ribbonValueText',
      className: '',
      x: 40,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Value',
      localize: true,
      maxWidth: 120,
      maxHeight: 36,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fffeff',
        stroke: '#a80034',
        strokeThickness: 3,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#a80034',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '902ef33a-efa0-471a-bf6f-0afb0621bcaa'
    },
    {
      id: '92d5efad-0b96-486a-b7ca-6f3a26589401',
      type: 'Text',
      name: 'ribbonMultiText',
      className: '',
      x: -41,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x6',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffec71',
        stroke: '#761d0f',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#761d0f',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '902ef33a-efa0-471a-bf6f-0afb0621bcaa'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'basic_offer',
    'special_offer'
  ],
  handleResize: false
} as const;

export class ShopOfferLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  background!: Sprite;
  coinRewardText!: Text;
  offerName!: Text;
  buyButton!: Container;
  legacyRibbonValue!: Container;
  coinsShadow!: Sprite;
  rewardsLayout!: ShopOfferRewardsLayout;
  bannerContainer!: Graphics;
  timerContainer!: Container;
  nineSliceButton!: ButtonLargeLayout & { data: typeof raw['list'][11]['data'] };
  priceLabelText!: Text;
  banner!: Sprite;
  bannerText!: Text;
  timer!: Sprite;
  timerText!: Text;
  ribbonValueText!: Text;
  ribbonMultiText!: Text;
  StateName!: 'basic_offer' | 'special_offer';

  constructor() {
    populate(this, raw);
  }
}
